import DefaultStoryThreadLayout from "@pages/StoryThread/layouts/DefaultStoryThreadLayout.tsx";

export const StoryThreadLayout = (urlPath: string) => {
  switch (urlPath) {
    default:
      return DefaultStoryThreadLayout;
  }
};
